import React from 'react'
import { RequestsTable } from './RequestsTable'
import AppShell from '../../../../Components/AppShell'
import PageHeader from '../../../../Components/PageHeader'

const ScraperRequestPage = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Listings"
        title="Scraper requests"
        subtitle="Review download requests and request status."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Listings', to: '/listings-tools' },
          { label: 'Web Scrapers', to: '/listings-tool/web_scrapers' },
          { label: 'Downloads' },
        ]}
      />
      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        <RequestsTable />
      </div>
    </AppShell>
  )
}

export default ScraperRequestPage
